import {Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ButtonTypeEnum} from '@shared/button/button.directive';
import {MemoizedSelector, Store} from '@ngrx/store';
import {LibrarySelectors} from '@store/library';
import {ChapterBookDetailsInterface} from '@shared/interfaces/chapter.interface';
import {SelectionActions, SelectionSelectors} from '@store/selection';
import {AbstractSelect} from '@shared/abstract/select/abstract.select';
import {ClassHelper} from '@shared/modules/content/modules/helpers/dom/class.helper';

export enum ModuleSingleSelectPlaceHolder {
    All = 'moduleMenu.all',
    SelectOne = 'moduleMenu.selectOne',
}

@Component({
    selector: 'app-chapter-select',
    templateUrl: './chapter-select.component.html',
    styleUrls: ['./chapter-select.component.scss'],
})
export class ChapterSelectComponent extends AbstractSelect<ChapterBookDetailsInterface> implements OnInit {
    readonly buttonType = ButtonTypeEnum;

    @HostBinding('class') readonly classes: string[] = ['module-menu'];

    @ViewChild('searchInput') searchInputRef?: ElementRef<HTMLInputElement>;

    @Input() disabled?: boolean = false;

    @Input() outputChanges: boolean = false;

    @Input() autoSelectFirstItem: boolean = false;

    @Input() ellipsisMax?: number;

    @Input() classModifiers: string[] = [];

    @Input() placeHolder: ModuleSingleSelectPlaceHolder = ModuleSingleSelectPlaceHolder.All;

    @Output()
    readonly selectChange: EventEmitter<number> = new EventEmitter();

    @Input() enableSearch: boolean = false;

    searchTerm: string = '';

    elementWidth!: string;

    classHelper: ClassHelper = new ClassHelper('');

    constructor(private elementRef: ElementRef, store: Store) {
        super(store);
    }

    handleClick(chapter?: ChapterBookDetailsInterface, index: number = 0): void {
        this.dispatch(SelectionActions.setChapter({item: chapter}));

        if (this.outputChanges) {
            const chapterId = index === 0 ? 1 : index + 1;

            this.selectChange.emit(chapterId);
        }
    }

    ngOnInit() {
        super.ngOnInit();
        this.classHelper.addClasses(this.classModifiers);

        if (this.autoSelectFirstItem && !this.selectedItem && this.items && this.items.length > 0) {
            this.selectedItem = this.items[0];
        }
    }

    updateMenuWidth(): void {
        this.elementWidth = `${this.elementRef.nativeElement.offsetWidth / 10}rem`;

        if (this.enableSearch && this.searchInputRef) {
            setTimeout(() => {
                this.searchInputRef?.nativeElement.focus();
            }, 100);
        }
    }

    protected getItemSelector(): MemoizedSelector<object, ChapterBookDetailsInterface | undefined> {
        return SelectionSelectors.selectChapter;
    }

    protected getItemsSelector(): MemoizedSelector<object, ChapterBookDetailsInterface[] | undefined> {
        return LibrarySelectors.selectBookChapters;
    }

    protected filterItems(items: ChapterBookDetailsInterface[]): ChapterBookDetailsInterface[] {
        return items;
    }
}
